import * as React from 'react';
import Metrics from 'src/entities/Metrics';

export interface Props {
  metrics: Metrics;
}

class MetricsComponent extends React.PureComponent<Props> {
  public render(): React.ReactNode {

    return (
      <div className="container-fluid box-home-shadow">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-4 col-md-4 text-center">
              <div className="box-home border-right">
                <p className="f-w-100 f-s-22">
                  <strong>
                    {Number(this.props.metrics.totalInvested).toLocaleString('es')} €
                  </strong>
                  <br/>
                  Invertidos en startups
                </p>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 text-center">
              <div className="box-home border-right">
                <p className="f-w-100 f-s-22">
                  <strong>
                    {this.props.metrics.totalFunded}
                  </strong>
                  <br/>
                  Operaciones financiadas
                </p>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 text-center">
              <div className="box-home">
                <p className="f-w-100 f-s-22">
                  <strong>
                    {this.props.metrics.registeredInvestors.toLocaleString('es')}
                  </strong>
                  <br/>
                  Inversores registrados
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MetricsComponent;


// WEBPACK FOOTER //
// ./src/modules/home/partials/Metrics.component.tsx